"use client";

import { useMemo } from "react";
import { useSession } from "next-auth/react";
import {
  buildClassRegistrationPath,
  buildClassRegistrationSignInUrl,
} from "@/lib/utils/classRegistrationRedirect";

export function useClassRegistrationCta(
  classId: number,
  allowOnlineRegistration: boolean | null | undefined = true,
) {
  const { status } = useSession();

  const canRegisterOnline = allowOnlineRegistration !== false;
  const isSessionLoading = status === "loading";

  const registerHref = useMemo(() => {
    if (!canRegisterOnline || classId <= 0) return null;
    if (status === "authenticated") {
      return buildClassRegistrationPath(classId);
    }
    if (status === "unauthenticated") {
      return buildClassRegistrationSignInUrl(classId);
    }
    return null;
  }, [status, classId, canRegisterOnline]);

  return {
    canRegisterOnline,
    isSessionLoading,
    registerHref,
    showCta: canRegisterOnline,
    isAuthenticated: status === "authenticated",
  };
}
